var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('div',{staticClass:"loginNow"},[(_vm.login)?_c('LoginForm'):_vm._e(),(_vm.register)?_c('RegisterForm'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }